module.exports = __webpack_public_path__ + "staticcomp/img/top.9d308d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/6/top.jpg
// module id = 00XS
// module chunks = 39